import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import EquipoView from "../views/EquipoView.vue";
import AboutView from "../views/AboutView.vue";
import RepresentadasView from "../views/RepresentadasView.vue";
import CotizacionView from "../views/CotizacionView.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      title: "Alfa Pack, Hacemos La Diferencia",
    },
    component: HomeView,
  },
  {
    path: "/nosotros",
    name: "nosotros",
    meta: {
      title: "Nosotros",
    },
    component: AboutView,
  },
  {
    path: "/equipo",
    name: "equipo",
    meta: {
      title: "Equipo",
    },
    component: EquipoView,
  },
  {
    path: "/representadas",
    name: "representadas",
    meta: {
      title: "Marcas Representadas",
    },
    component: RepresentadasView,
  },
  {
    path: "/cotizaciones",
    name: "cotizaciones",
    meta: {
      title: "Cotizaciones",
    },
    component: CotizacionView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  document.title = (to.meta?.title as string) ?? "Alfa Pack";
});
export default router;
